import { RestructureApprovalStatus } from "../../../graphql/generated";
import { toHumanReadable } from "../../../utils/string";

export const approvalStatusOptions = Object.values(
  RestructureApprovalStatus
).map((value) => {
  return { value, label: toHumanReadable(value) };
});
